export default "__VITE_ASSET__BItrZ42B__"